import { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { PiCookieBold } from "react-icons/pi";
import Cookies from 'js-cookie';
import ReactGA from "react-ga4";

export default function CookiePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Open the cookie popup if cookie_consent doesn't exist in app cookies.
    if (Cookies.get("cookies_consent") === undefined) {
      setOpen(true);
    }
  }, []);

  /**
   * Creates "cookies_consent" to keep track if the user was already prompted with cookies popup and initializes Google Analytics.
   */
  function acceptCookies() {
    Cookies.set("cookies_consent", true);
    try {
      ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID); // initialize Google Analytics with measurement ID
    }
    catch (e) {
      console.log("GA Initialization failed:", e);
    }
    finally {
      // ReactGA.send({ hitType: "pageview", page: "/" });
      setOpen(false);
    }
  }

  /**
   * Creates "cookies_consent" to keep track if the user was already prompted with cookies popup and closes the popup.
   */
  function denyCookies() {
    Cookies.set("cookies_consent", false);
    // Should remove existing cookies related to Google Analytics
    Cookies.remove('_ga')
    Cookies.remove(`_ga_${process.env.REACT_APP_GA_MEASUREMENT_ID.substring(2)}`)
    setOpen(false);
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" onClose={() => null}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                        <PiCookieBold className="h-6 w-6 text-blue-600" aria-hidden="true" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                          We use cookies
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            We use cookies to enhance your browsing experience and improve our website's performance.
                            By clicking "Allow Cookies," you agree to the use of cookies on our website.
                            These cookies help us analyze and understand how you interact with our site,
                            which enables us to optimize our content and make your visits more enjoyable.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                      onClick={() => acceptCookies()}
                    >
                      Allow Cookies
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => denyCookies()}
                    >
                      Don't Allow
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
